
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'sidebar',
  emits: ['themeChanged'],
  data() {
    return {
      isDarkModeOn: false
    }
  },
  computed: {
    changeBtnText() {
      if(this.isDarkModeOn) {
        return 'Disable dark mode'
      }
      return 'Enable dark mode'
    }
  },
  methods: {
    toggleTheme() {
      this.isDarkModeOn = !this.isDarkModeOn;
      this.$emit('themeChanged', this.isDarkModeOn);
    }
  }
});
